<template>
<v-container class="my-5">
    <h4 class="text-center mb-4">Zvolený upratovač</h4>
    <v-card
        class="mx-auto my-4"
        max-width="374"
    >
    <template slot="progress">
        <v-progress-linear
            color="deep-purple"
            height="10"
            indeterminate>
        </v-progress-linear>
    </template>
    <v-card-title>
        <v-row>
            <v-avatar class="ml-4" color="blue-grey">
                <v-icon dark>
                    mdi-account-circle
                </v-icon>
            </v-avatar>
            <p v-if="pickedPerson" class="mx-auto my-auto">
                {{pickedPerson.name}} {{pickedPerson.surname}} - {{pickedPerson.term}}
            </p>
        </v-row>
    </v-card-title>
    </v-card>
</v-container>
</template>

<script>
    export default {
        name: "PickedPerson",
        data: () => ({
            personId : null,
            person : {
                "id": 1,
                "name": 'Mária',
                "surname": 'Upratovačka',
                "price": 3.5,
                "personal_info": "Nerád upratuješ ? Nebaví ťa stále sa hádať so spolubývajúcimi, že ty si mal službu minulý týždeň ? žiaden problém! Upratovanie je moja záľuba.",
                "rating": 5
            },
        }),
        props: ["pickedPerson"]
    }
</script>
